import React from 'react';
import Carousel from './Carousel/Carousel';
import Feedback from './Feedback/Feedback';
import PremiumPlans from './PremiumPlans/PremiumPlans';
import Testimonial from './Testimonial/Testimonial';
import Answer from './WhyUs/Answer';
import Button from './Button-Component/Button';
import Free from './FreeServices/FreeServices';
import IndustryExperts from './IndustryExperts/IndustryExperts';
import Abhay from './Abhay-Component/Abhay'
import Working from './Working/Working';
import JourneyWithUs from './JourneyWithUs/JourneyWithUs';
import FaqFooter from './FAQ/FaqFooter'
import OurCounselors from '../AboutUs/OurCounselors';
import StudentTestimonial from '../BecomeACounselor/StudentTestimonial';



const Home = () => {
    return (
        <div className='bg-slate-50'>
            <Carousel />
            <Button />
            <IndustryExperts />
            <Abhay />
            <Working />
            <JourneyWithUs />
            <Answer />
            <OurCounselors />
            <StudentTestimonial />
            <Testimonial />
            <PremiumPlans />
            <Free />
            <Feedback />
            {/* <FaqFooter /> */}
        </div>
    );
};

export default Home;